module.exports = __webpack_public_path__ + "static/img/5.cb49649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5.png
// module id = bj4H
// module chunks = 4